(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dm-delivery-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dm-delivery-estimate')) {
  customElements.define('dm-delivery-estimate', class extends HTMLElement {
    connectedCallback() {
      this.updateDates();
      this.timer = setInterval(() => this.updateDates(), 60000);
      this.formRoot = this.closest('[id^="dm-pdp-"]');
      this.variantChange = (event) => {
        if (event.detail && event.detail.variant) this.hidden = !event.detail.variant.available;
      };
      if (this.formRoot) this.formRoot.addEventListener('change', this.variantChange);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      if (this.formRoot) this.formRoot.removeEventListener('change', this.variantChange);
    }
    updateDates() {
      const parts = new Intl.DateTimeFormat('en-CA', {timeZone:'Europe/Berlin',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
      const value = type => Number(parts.find(part => part.type === type).value);
      const today = new Date(Date.UTC(value('year'), value('month') - 1, value('day')));
      const addWorkdays = count => {
        const date = new Date(today);
        while (count > 0) {
          date.setUTCDate(date.getUTCDate() + 1);
          if (date.getUTCDay() !== 0 && date.getUTCDay() !== 6) count--;
        }
        return date;
      };
      const start = addWorkdays(16);
      const end = addWorkdays(21);
      const format = new Intl.DateTimeFormat(this.dataset.locale || 'en', {day:'2-digit',month:'short',year:'numeric',timeZone:'UTC'});
      this.querySelector('[data-date-range]').textContent = format.formatRange ? format.formatRange(start,end) : format.format(start) + ' – ' + format.format(end);
      this.querySelector('[data-date-item]').hidden = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
